module.exports = __webpack_public_path__ + "img/sx.7aeaac8c.svg";